export const BILLING_PERIOD_MONTHLY = "monthly";
export const BILLING_PERIOD_YEARLY = "yearly";

export const BILLING_PERIODS = [BILLING_PERIOD_MONTHLY, BILLING_PERIOD_YEARLY];

// Yearly plans are billed as 12 months minus 2 free months.
export const YEARLY_FREE_MONTHS = 2;
export const MONTHS_IN_YEAR = 12;
export const YEARLY_BILLED_MONTHS = MONTHS_IN_YEAR - YEARLY_FREE_MONTHS;

export const planPrices = {
  STANDARD: 10,
  BASIC: 15,
  PLUS: 20,
};

export const yearlyPlanPrices = Object.fromEntries(
  Object.entries(planPrices).map(([plan, monthlyPrice]) => [
    plan,
    monthlyPrice * YEARLY_BILLED_MONTHS,
  ]),
);

export const isYearlyBillingPeriod = (billingPeriod) =>
  billingPeriod === BILLING_PERIOD_YEARLY;

// Normalizes any raw value (e.g. from a checkout query string) to a known period.
export const normalizeBillingPeriod = (billingPeriod) =>
  isYearlyBillingPeriod(billingPeriod)
    ? BILLING_PERIOD_YEARLY
    : BILLING_PERIOD_MONTHLY;

// Returns the price charged per billing cycle for the given plan identifier
// (e.g. "standard") and billing period. Falls back to 0 for unknown plans.
export const getPlanPrice = (
  planIdentifier,
  billingPeriod = BILLING_PERIOD_MONTHLY,
) => {
  const planKey = String(planIdentifier || "").toUpperCase();
  const prices = isYearlyBillingPeriod(billingPeriod)
    ? yearlyPlanPrices
    : planPrices;

  return prices[planKey] ?? 0;
};

// Full price of a year at the monthly rate, used to show the yearly saving.
export const getYearlyFullPrice = (planIdentifier) =>
  getPlanPrice(planIdentifier, BILLING_PERIOD_MONTHLY) * MONTHS_IN_YEAR;
